import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  // NOTE: step は入力欄が受け付ける刻み。指定した欄だけ小数点（全角「．」含む）を許可し、
  //       刻みに合わない値が入っていたら警告を出す。未指定なら整数のみ。
  static values = { default: String, step: Number };

  change(event) {
    const target = event.currentTarget;

    const disallowedPattern = this.allowsDecimal ? /[^0-9.-]/g : /[^0-9-]/g;
    const converted = target.value
      .replace(/[０-９]/g, (n) => '０１２３４５６７８９'.indexOf(n))
      .replace(/[．]/g, '.')
      .replace(/[−ー]/g, '-')
      .replace(disallowedPattern, '');

    // NOTE: 先頭以外のマイナス記号を削除（先頭のマイナスのみ許可）
    let value = converted.replace(/^(-?).*$/, (match, minus) => minus + match.slice(minus.length).replace(/-/g, ''));

    if (this.allowsDecimal) {
      // NOTE: 2つ目以降の小数点を削除（最初の1つのみ許可）
      const [integerPart, ...decimalParts] = value.split('.');
      if (decimalParts.length > 0) {
        value = `${integerPart}.${decimalParts.join('')}`;
      }
    }

    if (value.length > 0 && value !== '-' && value !== '.' && value !== '-.') {
      target.value = value;
    } else {
      target.value = this.hasDefaultValue ? this.defaultValue : '0';
    }

    this.warnUnlessStepValue(target);
  }

  // NOTE: 小数点を許可するのは刻みが小数のときだけ（step: 1 の欄に「1.5」を入れられては困る）
  get allowsDecimal() {
    return this.hasStepValue && !Number.isInteger(this.stepValue);
  }

  // NOTE: 刻みに合わない値は勝手に丸めず、保存前に気付けるよう欄を赤くしてメッセージを出す
  //       （保存時はサーバ側のバリデーションで弾かれる）
  warnUnlessStepValue(target) {
    if (!this.hasStepValue) return;

    const number = Number(target.value);
    const matchesStep = Number.isFinite(number) && Number.isInteger(number / this.stepValue);

    target.closest('.form-group')?.classList.toggle('has-error', !matchesStep);
    if (!matchesStep) window.App.notifyError(`${this.stepValue}刻みで入力してください`);
  }
}
